import { useQuery } from '@tanstack/react-query';
import { templateApi } from '../api';
import { queryKeys } from '../queries/keys';
import type { TemplateAnnotation } from '../types';

export interface TemplateAnnotationsPayload {
  annotations: TemplateAnnotation[];
  count: number;
}

export interface TemplateAnnotationsState {
  annotations: TemplateAnnotation[];
  /** Raw query payload; compare by reference when seeding local overlay state. */
  data: TemplateAnnotationsPayload | undefined;
  loading: boolean;
}

/** Saved template-match instruments for one drawing (bbox overlays on the canvas). */
export function useTemplateAnnotations(
  docId: string | null | undefined,
): TemplateAnnotationsState {
  const query = useQuery({
    queryKey: queryKeys.templateAnnotations(docId ?? ''),
    queryFn: () => templateApi.listAnnotations(docId!),
    enabled: Boolean(docId),
  });

  return {
    annotations: query.data?.annotations ?? [],
    data: query.data,
    loading: query.isPending && Boolean(docId),
  };
}
